import React from 'react';
import { NumericFormat } from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const PercentageFormatInput = React.forwardRef<HTMLInputElement, CustomProps>(
  function PercentageFormatInput(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        suffix="%"
        allowNegative={false}
        decimalSeparator=","
        thousandSeparator="."
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
      />
    );
  },
);
